export default __webpack_public_path__ + "static/media/cases5@2x.7731bcd5.webp";